<template>
  <div class="mt-3 mb-1">
    <validation-observer ref="form">

      <b-row>
        <b-col
          lg="8"
          md="10"
          sm="12"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('payment.receipt')"
            rules="required"
          >
            <b-form-group
              :label="$t('payment.receipt')"
              label-for="file-wiretransfer"
              label-cols-sm="3"
              label-size="lg"
            >
              <b-form-file
                id="file-wiretransfer"
                v-model="file"
                size="lg"
                :state="errors.length > 0 ? false:null"
                @input="$emit('input', $event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormFile, BFormGroup,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'WireTransferInput',
  components: {
    BFormFile,
    BFormGroup,
    BRow,
    BCol,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: [Blob, String],
      default: null,
    },
  },
  data() {
    return {
      required,
      file: null,
    }
  },
  methods: {
    async validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>

<style scoped>

</style>
